export const MonamodiFuneralPlan =[
    {
        "created_at": "2023-10-25T06:30:48.656Z",
        "guid": "e7659571-ea97-46a7-8e6e-4b70a48461e3",
        "name": "Plan 1",
        "code": "Plan_1",
        "type": "Paid",
        "cover_type": "Individual",
        "minimum_age": 0,
        "maximum_age": 100,
        "waiting_period_days": 30,
        "lapse_period_days": 120,
        "cool_off_period_hours": 30,
        "debit_grace_days": 30,
        "partner_guid": "accessbank",
        "eligibility_threshold": 0,
        "active": true,
        "tag": "",
        "notes": "",
        "membership_configs": {
            "guid": "6eda9bf0-cf63-481d-8f74-0f2052d64e9e",
            "product_guid": "e7659571-ea97-46a7-8e6e-4b70a48461e3",
            "created_at": "2024-02-23T14:04:27.909Z",
            "content": {
                "nuclear": [
                    {
                        "relationship": "Principal",
                        "age_range": {
                            "min": 18,
                            "max": 74
                        },
                        "max_count": 1
                    },
                    {
                        "relationship": "Spouse",
                        "age_range": {
                            "min": 18,
                            "max": 75
                        },
                        "max_count": 1
                    },
                    {
                        "relationship": "Child",
                        "age_range": {
                            "min": 0,
                            "max": 21
                        },
                        "max_count": 6
                    }
                ],
                "extended": [
                    {
                        "relationship": "Parent",
                        "age_range": {
                            "min": 18,
                            "max": 84
                        },
                        "max_count": 2,
                        "male_count": 1,
                        "female_count": 1
                    },
                    {
                        "relationship": "Parent_In_Law",
                        "age_range": {
                            "min": 18,
                            "max": 84
                        },
                        "max_count": 2,
                        "male_count": 1,
                        "female_count": 1
                    },
                    {
                        "relationship": "Brother",
                        "age_range": {
                            "min": 0,
                            "max": 85
                        },
                        "max_count": 12,
                        "male_count": 12,
                        "female_count": 0
                    }
                ],
                "premiums": [
                    {
                        "entry_age": 18,
                        "exit_age": 84,
                        "benefit_amount": 750000,
                        "premium_rate": 1600,
                        "tableData": {
                            "id": 0
                        }
                    },
                    {
                        "entry_age": 0,
                        "exit_age": 15,
                        "benefit_amount": 300000,
                        "premium_rate": 530,
                        "tableData": {
                            "id": 1
                        }
                    },
                    {
                        "entry_age": 16,
                        "exit_age": 25,
                        "benefit_amount": 300000,
                        "premium_rate": 819.9999999999999
                    }
                ],
                "members_payout_plan": [
                    {
                        "relationship": "Child",
                        "plans": [
                            {
                                "min_age": 16,
                                "max_age": 21,
                                "amount": 7500,
                                "tableData": {
                                    "id": 0
                                }
                            },
                            {
                                "min_age": 9,
                                "max_age": 15,
                                "amount": 3000,
                                "tableData": {
                                    "id": 1
                                }
                            },
                            {
                                "min_age": 6,
                                "max_age": 8,
                                "amount": 3000,
                                "tableData": {
                                    "id": 2
                                }
                            },
                            {
                                "min_age": 0,
                                "max_age": 5,
                                "amount": 2000,
                                "tableData": {
                                    "id": 3
                                }
                            }
                        ],
                        "tableData": {
                            "id": 0
                        }
                    }
                ],
                "add_ons": [
                    {
                        "name": "Tombstone",
                        "benefit_amount_in_cents": 1200000,
                        "premium_amount_in_cents": 2500,
                        "allowed_relationships": [
                            "Member Only"
                        ],
                        "uuid": "e672ad78-fec5-47f9-8412-a4fbcee5e0af",
                        "tableData": {
                            "id": 0
                        }
                    },
                    {
                        "name": "Tombstone",
                        "benefit_amount_in_cents": 1200000,
                        "premium_amount_in_cents": 5400,
                        "allowed_relationships": [
                            "Member & Family"
                        ],
                        "uuid": "129d7bfc-b02b-43d6-97c9-f6c3101f1cd8",
                        "tableData": {
                            "id": 1
                        }
                    },
                    {
                        "name": "Tombstone",
                        "benefit_amount_in_cents": 1200000,
                        "premium_amount_in_cents": 3300,
                        "allowed_relationships": [
                            "Parent_In_Law",
                            "Parent"
                        ],
                        "uuid": "9eaee746-60df-4c9d-b24d-360b31c7ac35",
                        "tableData": {
                            "id": 2
                        }
                    }
                ],
                "additionals": [
                    {
                        "name": "Group Life Assurance",
                        "benefit_amount_in_cents": 5000000,
                        "premium_amount_in_cents": 4000,
                        "type": "Family",
                        "tableData": {
                            "id": 0
                        }
                    },
                    {
                        "name": "12 months Premium Waiver",
                        "benefit_amount_in_cents": 1200,
                        "premium_amount_in_cents": 300,
                        "type": "Family",
                        "tableData": {
                            "id": 1
                        }
                    },
                    {
                        "name": "12 months Premium Waiver",
                        "benefit_amount_in_cents": 1200,
                        "premium_amount_in_cents": 200,
                        "type": "Parent",
                        "tableData": {
                            "id": 2
                        }
                    }
                ],
                "annuities": [
                    {
                        "months": "6",
                        "benefit_amount": 50000,
                        "premium_amount": 500,
                        "allowed_relationships": [
                            "Member Only"
                        ],
                        "uuid": "09fc797e-27e3-46a7-9480-cb4ed133bd48",
                        "tableData": {
                            "id": 0
                        }
                    }
                ],
                "premium_waivers": [
                    {
                        "months": "12",
                        "premium_amount": 300,
                        "allowed_relationships": [
                            "Member & Family"
                        ],
                        "uuid": "abeaa8e9-5df3-439f-b1b1-2307d5c29427",
                        "tableData": {
                            "id": 0
                        }
                    },
                    {
                        "months": "12",
                        "premium_amount": 200,
                        "allowed_relationships": [
                            "Parent",
                            "Parent_In_Law"
                        ],
                        "uuid": "6a7e3e96-6d8b-47f8-a8da-5ed1cb108f54",
                        "tableData": {
                            "id": 1
                        }
                    }
                ],
                "premium_nuclear": [
                    {
                        "type": "Member & Family",
                        "premium_amount": 2700,
                        "tableData": {
                            "id": 0
                        }
                    },
                    {
                        "type": "Member Only",
                        "premium_amount": 1800,
                        "uuid": "9fe7811e-aab4-42cd-b398-1d1d960d9c08",
                        "tableData": {
                            "id": 1
                        }
                    }
                ],
                "benefits_nuclear": [
                    {
                        "name": "Funeral",
                        "benefit_amount": 750000,
                        "tableData": {
                            "id": 0
                        }
                    }
                ]
            },
            "_id": "65d8a5eb9105f2f86c136504"
        },
        "premiums": [],
        "fixed_indemnities": [],
        "variable_indemnities": [],
        "cashback": []
    },
    {
        "created_at": "2023-10-25T06:33:19.137Z",
        "guid": "4aabbb4d-982e-46ff-a309-6bc6dfde3675",
        "name": "Plan 2",
        "code": "Plan_2",
        "type": "Paid",
        "cover_type": "Family",
        "minimum_age": 0,
        "maximum_age": 100,
        "waiting_period_days": 30,
        "lapse_period_days": 120,
        "cool_off_period_hours": 30,
        "debit_grace_days": 5,
        "partner_guid": "accessbank",
        "eligibility_threshold": 0,
        "active": true,
        "tag": "",
        "notes": "",
        "membership_configs": {
            "guid": "c6f4c4df-69cf-4a10-9f22-4842181539da",
            "product_guid": "4aabbb4d-982e-46ff-a309-6bc6dfde3675",
            "created_at": "2025-03-12T15:33:37.190Z",
            "content": {
                "nuclear": [
                    {
                        "relationship": "Principal",
                        "age_range": {
                            "min": 18,
                            "max": 75
                        },
                        "max_count": 1
                    },
                    {
                        "relationship": "Spouse",
                        "age_range": {
                            "min": 18,
                            "max": 75
                        },
                        "max_count": 1
                    },
                    {
                        "relationship": "Child",
                        "age_range": {
                            "min": 0,
                            "max": 21
                        },
                        "max_count": 6
                    }
                ],
                "extended": [
                    {
                        "relationship": "Parent",
                        "age_range": {
                            "min": 18,
                            "max": 84
                        },
                        "max_count": 2,
                        "male_count": 1,
                        "female_count": 1
                    },
                    {
                        "relationship": "Parent_In_Law",
                        "age_range": {
                            "min": 18,
                            "max": 84
                        },
                        "max_count": 2,
                        "male_count": 1,
                        "female_count": 1
                    }
                ],
                "premiums": [
                    {
                        "entry_age": 18,
                        "exit_age": 84,
                        "benefit_amount": 1000000,
                        "premium_rate": 1800,
                        "tableData": {
                            "id": 0
                        }
                    }
                ],
                "members_payout_plan": [
                    {
                        "relationship": "Child",
                        "plans": [
                            {
                                "min_age": 16,
                                "max_age": 21,
                                "amount": 10000,
                                "tableData": {
                                    "id": 0
                                }
                            },
                            {
                                "min_age": 9,
                                "max_age": 15,
                                "amount": 5000,
                                "tableData": {
                                    "id": 1
                                }
                            },
                            {
                                "min_age": 6,
                                "max_age": 8,
                                "amount": 5000,
                                "tableData": {
                                    "id": 2
                                }
                            },
                            {
                                "min_age": 0,
                                "max_age": 5,
                                "amount": 3000,
                                "tableData": {
                                    "id": 3
                                }
                            }
                        ],
                        "tableData": {
                            "id": 0
                        }
                    }
                ],
                "add_ons": [
                    {
                        "name": "Tombstone",
                        "benefit_amount_in_cents": 1200000,
                        "premium_amount_in_cents": 5400,
                        "allowed_relationships": [
                            "Member & Family"
                        ],
                        "uuid": "74b7fa13-0638-48cc-81f4-3fd7d1b20894",
                        "tableData": {
                            "id": 0
                        }
                    },
                    {
                        "name": "Tombstone",
                        "benefit_amount_in_cents": 1200000,
                        "premium_amount_in_cents": 2500,
                        "allowed_relationships": [
                            "Member Only"
                        ],
                        "uuid": "ce9015f9-da77-48ec-99dc-9ad2de6d8870",
                        "tableData": {
                            "id": 1
                        }
                    },
                    {
                        "name": "Tombstone",
                        "benefit_amount_in_cents": 1200000,
                        "premium_amount_in_cents": 3300,
                        "allowed_relationships": [
                            "Parent_In_Law",
                            "Parent"
                        ],
                        "uuid": "ae72c66a-77ae-439b-ad89-29b33eaeffa4",
                        "tableData": {
                            "id": 2
                        }
                    }
                ],
                "premium_nuclear": [
                    {
                        "type": "Member Only",
                        "premium_amount": 2200,
                        "uuid": "08f9b454-e5fe-400f-8042-c60b3f82bbff",
                        "tableData": {
                            "id": 0
                        }
                    },
                    {
                        "type": "Member & Family",
                        "premium_amount": 3600,
                        "uuid": "a24cbc0d-7209-45b8-b3ff-6b4a78edf9dd",
                        "tableData": {
                            "id": 1
                        }
                    }
                ],
                "benefits_nuclear": [
                    {
                        "name": "Funeral",
                        "benefit_amount": 1000000,
                        "tableData": {
                            "id": 0
                        }
                    }
                ],
                "premium_waivers": [
                    {
                        "months": "12",
                        "premium_amount": 350,
                        "allowed_relationships": [
                            "Member & Family"
                        ],
                        "uuid": "49ab4007-bf23-402a-830e-68be08cdcf9b",
                        "tableData": {
                            "id": 0
                        }
                    },
                    {
                        "months": "12",
                        "premium_amount": 220.00000000000003,
                        "allowed_relationships": [
                            "Parent_In_Law",
                            "Parent"
                        ],
                        "uuid": "642c1fcc-a911-4de8-af62-751fb98e3b37",
                        "tableData": {
                            "id": 1
                        }
                    }
                ],
                "annuities": [
                    {
                        "months": "6",
                        "benefit_amount": 50000,
                        "premium_amount": 500,
                        "allowed_relationships": [
                            "Member Only"
                        ],
                        "uuid": "5f16ad12-571f-444f-ac33-ea2f0c1adefe",
                        "tableData": {
                            "id": 0
                        }
                    }
                ]
            },
            "_id": "67d1a95174e3e10bd693c4a6"
        },
        "premiums": [
            {
                "guid": "3afcbf06-a76e-43ae-9421-6d0e4f5a506d",
                "product_guid": "4aabbb4d-982e-46ff-a309-6bc6dfde3675",
                "granularity": "Month",
                "cardinality": 1,
                "amount_in_cents": 3600,
                "payment_method": "Mobile_Money",
                "active": true,
                "max_age": null,
                "min_age": null,
                "created_at": "2023-10-25T06:33:40.467Z"
            }
        ],
        "fixed_indemnities": [
            {
                "created_at": "2023-10-25T06:34:19.383Z",
                "guid": "8a3d959f-fd26-4e36-96cc-985345b93d82",
                "product_guid": "4aabbb4d-982e-46ff-a309-6bc6dfde3675",
                "name": "Funeral",
                "amount_benefit": 10000,
                "principal_max_age_limit": 100,
                "spouse_max_age_limit": 100,
                "spouse_min_age_limit": 18,
                "child_max_age_limit": 25
            }
        ],
        "variable_indemnities": [],
        "cashback": []
    },
    {
        "created_at": "2024-01-31T08:20:15.445Z",
        "guid": "833f85fa-e7e3-444d-bf5a-b08371617f41",
        "name": "Plan 3",
        "code": "Plan_3",
        "type": "Paid",
        "cover_type": "Family",
        "minimum_age": 0,
        "maximum_age": 120,
        "waiting_period_days": 150,
        "lapse_period_days": 120,
        "cool_off_period_hours": 0,
        "debit_grace_days": 30,
        "partner_guid": "accessbank",
        "eligibility_threshold": 0,
        "active": true,
        "tag": "",
        "notes": "",
        "membership_configs": {
            "guid": "2349c196-196b-46f9-bf04-503d2fdce701",
            "product_guid": "833f85fa-e7e3-444d-bf5a-b08371617f41",
            "created_at": "2024-01-31T08:50:24.855Z",
            "content": {
                "nuclear": [
                    {
                        "relationship": "Principal",
                        "age_range": {
                            "min": 18,
                            "max": 74
                        },
                        "max_count": 1
                    },
                    {
                        "relationship": "Spouse",
                        "age_range": {
                            "min": 18,
                            "max": 74
                        },
                        "max_count": 1
                    },
                    {
                        "relationship": "Child",
                        "age_range": {
                            "min": 0,
                            "max": 21
                        },
                        "max_count": 6
                    }
                ],
                "extended": [
                    {
                        "relationship": "Parent",
                        "age_range": {
                            "min": 18,
                            "max": 84
                        },
                        "max_count": 2,
                        "male_count": 1,
                        "female_count": 1
                    },
                    {
                        "relationship": "Parent_In_Law",
                        "age_range": {
                            "min": 18,
                            "max": 84
                        },
                        "max_count": 2,
                        "male_count": 1,
                        "female_count": 1
                    }
                ],
                "premiums": [
                    {
                        "entry_age": 18,
                        "exit_age": 84,
                        "benefit_amount": 1500000,
                        "premium_rate": 2700,
                        "tableData": {
                            "id": 0
                        }
                    }
                ],
                "members_payout_plan": [],
                "add_ons": [
                    {
                        "name": "Tombstone",
                        "benefit_amount_in_cents": 1200000,
                        "premium_amount_in_cents": 2500,
                        "allowed_relationships": [
                            "Member Only"
                        ],
                        "uuid": "db4c2530-756e-47cc-882a-d59d79acf358",
                        "tableData": {
                            "id": 0
                        }
                    },
                    {
                        "name": "Tombstone",
                        "benefit_amount_in_cents": 1200000,
                        "premium_amount_in_cents": 5400,
                        "allowed_relationships": [
                            "Member & Family"
                        ],
                        "uuid": "76cad372-4eaa-4d92-a0db-072029765b05",
                        "tableData": {
                            "id": 1
                        }
                    },
                    {
                        "name": "Tombstone",
                        "benefit_amount_in_cents": 1200000,
                        "premium_amount_in_cents": 3300,
                        "allowed_relationships": [
                            "Parent",
                            "Parent_In_Law"
                        ],
                        "uuid": "450b26d2-56dd-433d-9992-4e55af646620"
                    }
                ],
                "premium_nuclear": [
                    {
                        "type": "Member Only",
                        "premium_amount": 3200,
                        "uuid": "78adbb6d-7890-4063-957b-232fb2fa202b",
                        "tableData": {
                            "id": 0
                        }
                    },
                    {
                        "type": "Member & Family",
                        "premium_amount": 5300,
                        "uuid": "98c07b76-937f-4d1c-95f4-f390f3bbd2c7",
                        "tableData": {
                            "id": 1
                        }
                    }
                ],
                "benefits_nuclear": [
                    {
                        "name": "Funeral",
                        "benefit_amount": 1500000,
                        "uuid": "94a497a7-c44b-4934-a56d-247f7d6a5163",
                        "tableData": {
                            "id": 0
                        }
                    }
                ],
                "premium_waivers": [
                    {
                        "months": "12",
                        "premium_amount": 500,
                        "allowed_relationships": [
                            "Member & Family"
                        ],
                        "uuid": "04461dd1-b985-49c5-b42a-504d5bcb6ee1",
                        "tableData": {
                            "id": 0
                        }
                    },
                    {
                        "months": "12",
                        "premium_amount": 250,
                        "allowed_relationships": [
                            "Member Only"
                        ],
                        "uuid": "be1422fa-d77d-454b-b953-e3fdb1b51aca",
                        "tableData": {
                            "id": 1
                        }
                    }
                ],
                "annuities": [
                    {
                        "months": "6",
                        "benefit_amount": 50000,
                        "premium_amount": 500,
                        "allowed_relationships": [
                            "Member Only"
                        ],
                        "uuid": "a456f92f-fb0c-44af-b807-6ae7809433d7",
                        "tableData": {
                            "id": 0
                        }
                    }
                ]
            },
            "_id": "65ba09d0f9ef7df443dde6b3"
        },
        "premiums": [],
        "fixed_indemnities": [],
        "variable_indemnities": [],
        "cashback": []
    },
    {
        "created_at": "2024-01-31T08:21:10.151Z",
        "guid": "8927ded2-69e3-4cdd-baee-421aed5bb65b",
        "name": "Plan 4",
        "code": "Plan_4",
        "type": "Paid",
        "cover_type": "Family",
        "minimum_age": 0,
        "maximum_age": 120,
        "waiting_period_days": 150,
        "lapse_period_days": 120,
        "cool_off_period_hours": 0,
        "debit_grace_days": 30,
        "partner_guid": "accessbank",
        "eligibility_threshold": 0,
        "active": true,
        "tag": "",
        "notes": "",
        "membership_configs": {
            "guid": "700565a3-e4c4-494e-9974-e7fdca28445e",
            "product_guid": "8927ded2-69e3-4cdd-baee-421aed5bb65b",
            "created_at": "2024-03-06T11:02:39.415Z",
            "content": {
                "nuclear": [
                    {
                        "relationship": "Principal",
                        "age_range": {
                            "min": 18,
                            "max": 75
                        },
                        "max_count": 1
                    },
                    {
                        "relationship": "Spouse",
                        "age_range": {
                            "min": 18,
                            "max": 75
                        },
                        "max_count": 1
                    },
                    {
                        "relationship": "Child",
                        "age_range": {
                            "min": 0,
                            "max": 21
                        },
                        "max_count": 6
                    }
                ],
                "extended": [
                    {
                        "relationship": "Parent",
                        "age_range": {
                            "min": 18,
                            "max": 84
                        },
                        "max_count": 2,
                        "male_count": 1,
                        "female_count": 1
                    },
                    {
                        "relationship": "Parent_In_Law",
                        "age_range": {
                            "min": 18,
                            "max": 84
                        },
                        "max_count": 2,
                        "male_count": 1,
                        "female_count": 1
                    }
                ],
                "premiums": [
                    {
                        "entry_age": 18,
                        "exit_age": 84,
                        "benefit_amount": 2000000,
                        "premium_rate": 3600,
                        "tableData": {
                            "id": 0
                        }
                    }
                ],
                "members_payout_plan": [],
                "add_ons": [
                    {
                        "name": "Tombstone",
                        "benefit_amount_in_cents": 1200000,
                        "premium_amount_in_cents": 2500,
                        "allowed_relationships": [
                            "Member Only"
                        ],
                        "uuid": "cc714609-615a-4df3-aa72-0ef3009f8df2",
                        "tableData": {
                            "id": 0
                        }
                    },
                    {
                        "name": "Tombstone",
                        "benefit_amount_in_cents": 1200000,
                        "premium_amount_in_cents": 5400,
                        "allowed_relationships": [
                            "Member & Family"
                        ],
                        "uuid": "6acebd8e-73cc-4a91-9304-cf93bc558659",
                        "tableData": {
                            "id": 1
                        }
                    },
                    {
                        "name": "Tombstone",
                        "benefit_amount_in_cents": 1200000,
                        "premium_amount_in_cents": 3300,
                        "allowed_relationships": [
                            "Parent_In_Law",
                            "Parent"
                        ],
                        "uuid": "bb1d30b2-d5f8-4d35-a738-574c34e768ca",
                        "tableData": {
                            "id": 2
                        }
                    }
                ],
                "benefits_nuclear": [
                    {
                        "name": "Funeral",
                        "benefit_amount": 2000000,
                        "uuid": "34a8327e-ae41-46fc-b773-0cd7e7e7f51c",
                        "tableData": {
                            "id": 0
                        }
                    }
                ],
                "premium_nuclear": [
                    {
                        "type": "Member Only",
                        "premium_amount": 4500,
                        "uuid": "58d40ff8-c160-496c-b485-b3ea6477f282",
                        "tableData": {
                            "id": 0
                        }
                    },
                    {
                        "type": "Member & Family",
                        "premium_amount": 7800,
                        "uuid": "8b5051eb-b5d6-4b63-be5b-3907a7be642d",
                        "tableData": {
                            "id": 1
                        }
                    }
                ],
                "premium_waivers": [
                    {
                        "months": "12",
                        "premium_amount": 800,
                        "allowed_relationships": [
                            "Member & Family"
                        ],
                        "uuid": "07365e89-b794-44dc-8f18-0c9032822a91",
                        "tableData": {
                            "id": 0
                        }
                    },
                    {
                        "months": "12",
                        "premium_amount": 300,
                        "allowed_relationships": [
                            "Parent",
                            "Parent_In_Law"
                        ],
                        "uuid": "eecc16bf-42ff-42ea-9d01-b3d334773114",
                        "tableData": {
                            "id": 1
                        }
                    }
                ],
                "annuities": [
                    {
                        "months": "6",
                        "benefit_amount": 50000,
                        "premium_amount": 500,
                        "allowed_relationships": [
                            "Member Only"
                        ],
                        "uuid": "767b7c9e-2a86-4d76-a18e-2ac21b90141d",
                        "tableData": {
                            "id": 0
                        }
                    }
                ]
            },
            "_id": "65e84d4fcf83d515744dc5f2"
        },
        "premiums": [],
        "fixed_indemnities": [],
        "variable_indemnities": [],
        "cashback": []
    },
    {
        "created_at": "2024-01-31T08:21:46.051Z",
        "guid": "fe743635-440c-463c-b8a2-48ea4ffbbf17",
        "name": "Plan 5",
        "code": "Plan_5",
        "type": "Paid",
        "cover_type": "Family",
        "minimum_age": 0,
        "maximum_age": 120,
        "waiting_period_days": 150,
        "lapse_period_days": 120,
        "cool_off_period_hours": 0,
        "debit_grace_days": 30,
        "partner_guid": "accessbank",
        "eligibility_threshold": 0,
        "active": true,
        "tag": "",
        "notes": "",
        "membership_configs": {
            "guid": "e5c65e55-37e3-416d-8dd6-29b127152082",
            "product_guid": "fe743635-440c-463c-b8a2-48ea4ffbbf17",
            "created_at": "2024-01-31T09:16:25.139Z",
            "content": {
                "nuclear": [
                    {
                        "relationship": "Principal",
                        "age_range": {
                            "min": 18,
                            "max": 75
                        },
                        "max_count": 1
                    },
                    {
                        "relationship": "Spouse",
                        "age_range": {
                            "min": 18,
                            "max": 75
                        },
                        "max_count": 1
                    },
                    {
                        "relationship": "Child",
                        "age_range": {
                            "min": 0,
                            "max": 21
                        },
                        "max_count": 6
                    }
                ],
                "extended": [
                    {
                        "relationship": "Parent_In_Law",
                        "age_range": {
                            "min": 18,
                            "max": 84
                        },
                        "max_count": 2,
                        "male_count": 1,
                        "female_count": 1
                    },
                    {
                        "relationship": "Parent",
                        "age_range": {
                            "min": 18,
                            "max": 84
                        },
                        "max_count": 2,
                        "male_count": 1,
                        "female_count": 1
                    }
                ],
                "premiums": [
                    {
                        "entry_age": 18,
                        "exit_age": 84,
                        "benefit_amount": 2500000,
                        "premium_rate": 4500,
                        "tableData": {
                            "id": 0
                        }
                    }
                ],
                "members_payout_plan": [],
                "add_ons": [
                    {
                        "name": "Tombstone",
                        "benefit_amount_in_cents": 1200000,
                        "premium_amount_in_cents": 2500,
                        "allowed_relationships": [
                            "Member Only"
                        ],
                        "uuid": "d0129d01-693c-4aeb-b77f-7242679e14d9",
                        "tableData": {
                            "id": 0
                        }
                    },
                    {
                        "name": "Tombstone",
                        "benefit_amount_in_cents": 1200000,
                        "premium_amount_in_cents": 5400,
                        "allowed_relationships": [
                            "Member & Family"
                        ],
                        "uuid": "d3f80fbd-837c-4000-aed2-4f0462da31f9",
                        "tableData": {
                            "id": 1
                        }
                    },
                    {
                        "name": "Tombstone",
                        "benefit_amount_in_cents": 1200000,
                        "premium_amount_in_cents": 3300,
                        "allowed_relationships": [
                            "Parent_In_Law",
                            "Parent"
                        ],
                        "uuid": "4b43214d-7d04-4420-8e03-3011c791fac1"
                    }
                ],
                "benefits_nuclear": [
                    {
                        "name": "Funeral",
                        "benefit_amount": 2500000,
                        "uuid": "587b7239-5bec-4259-a27b-ebd5bed5d346",
                        "tableData": {
                            "id": 0
                        }
                    }
                ],
                "premium_nuclear": [
                    {
                        "type": "Member Only",
                        "premium_amount": 5400,
                        "uuid": "f2a85d3a-6f81-48cb-95c5-bc24e4f4e845",
                        "tableData": {
                            "id": 0
                        }
                    },
                    {
                        "type": "Member & Family",
                        "premium_amount": 9400,
                        "uuid": "34e2ce8d-d6c5-423d-a8be-5de310b0e97c",
                        "tableData": {
                            "id": 1
                        }
                    }
                ],
                "premium_waivers": [
                    {
                        "months": "12",
                        "premium_amount": 950,
                        "allowed_relationships": [
                            "Member & Family"
                        ],
                        "uuid": "bc6126b7-f4a0-4f40-9408-55dff9991cba",
                        "tableData": {
                            "id": 0
                        }
                    },
                    {
                        "months": "12",
                        "premium_amount": 350,
                        "allowed_relationships": [
                            "Parent_In_Law",
                            "Parent"
                        ],
                        "uuid": "64e41c5e-7db8-42d8-a158-308b58c9fae3",
                        "tableData": {
                            "id": 1
                        }
                    }
                ],
                "annuities": [
                    {
                        "months": "6",
                        "benefit_amount": 50000,
                        "premium_amount": 500,
                        "allowed_relationships": [
                            "Member Only"
                        ],
                        "uuid": "8a487221-bd64-4124-90c5-0581251e5fb9",
                        "tableData": {
                            "id": 0
                        }
                    }
                ]
            },
            "_id": "65ba0fe9f9ef7df443dde74d"
        },
        "premiums": [],
        "fixed_indemnities": [],
        "variable_indemnities": [],
        "cashback": []
    },
    {
        "created_at": "2024-01-31T08:23:22.460Z",
        "guid": "55ee65c5-2cb8-4d26-bcb9-b0ab091388aa",
        "name": "Plan 6",
        "code": "Plan_6",
        "type": "Paid",
        "cover_type": "Family",
        "minimum_age": 0,
        "maximum_age": 120,
        "waiting_period_days": 150,
        "lapse_period_days": 120,
        "cool_off_period_hours": 0,
        "debit_grace_days": 30,
        "partner_guid": "accessbank",
        "eligibility_threshold": 0,
        "active": true,
        "tag": "",
        "notes": "",
        "membership_configs": {
            "guid": "e12439f2-c71b-45c5-add6-2f9ab0caf378",
            "product_guid": "55ee65c5-2cb8-4d26-bcb9-b0ab091388aa",
            "created_at": "2024-03-06T11:03:37.035Z",
            "content": {
                "nuclear": [
                    {
                        "relationship": "Principal",
                        "age_range": {
                            "min": 18,
                            "max": 75
                        },
                        "max_count": 1
                    },
                    {
                        "relationship": "Spouse",
                        "age_range": {
                            "min": 18,
                            "max": 75
                        },
                        "max_count": 1
                    },
                    {
                        "relationship": "Child",
                        "age_range": {
                            "min": 0,
                            "max": 21
                        },
                        "max_count": 6
                    }
                ],
                "extended": [
                    {
                        "relationship": "Parent",
                        "age_range": {
                            "min": 18,
                            "max": 84
                        },
                        "max_count": 2,
                        "male_count": 1,
                        "female_count": 1
                    },
                    {
                        "relationship": "Parent_In_Law",
                        "age_range": {
                            "min": 18,
                            "max": 84
                        },
                        "max_count": 2,
                        "male_count": 1,
                        "female_count": 1
                    }
                ],
                "premiums": [
                    {
                        "entry_age": 18,
                        "exit_age": 84,
                        "benefit_amount": 3000000,
                        "premium_rate": 5400,
                        "tableData": {
                            "id": 0
                        }
                    }
                ],
                "members_payout_plan": [],
                "add_ons": [
                    {
                        "name": "Tombstone",
                        "benefit_amount_in_cents": 1200000,
                        "premium_amount_in_cents": 2500,
                        "allowed_relationships": [
                            "Member Only"
                        ],
                        "uuid": "cbc210da-fc1e-498c-8508-7c78b8abc2df",
                        "tableData": {
                            "id": 0
                        }
                    },
                    {
                        "name": "Tombstone",
                        "benefit_amount_in_cents": 1200000,
                        "premium_amount_in_cents": 5400,
                        "allowed_relationships": [
                            "Member & Family"
                        ],
                        "uuid": "a709f4ac-ca7a-4e56-b94f-cf80c3672e28",
                        "tableData": {
                            "id": 1
                        }
                    },
                    {
                        "name": "Tombstone",
                        "benefit_amount_in_cents": 1200000,
                        "premium_amount_in_cents": 3300,
                        "allowed_relationships": [
                            "Parent",
                            "Parent_In_Law"
                        ],
                        "uuid": "da9875d7-102b-40ff-8c3c-05c5c6a3fadf",
                        "tableData": {
                            "id": 2
                        }
                    }
                ],
                "premium_nuclear": [
                    {
                        "type": "Member Only",
                        "premium_amount": 5800,
                        "uuid": "6e71edb7-962a-4810-ac57-a5b8eadb47bb",
                        "tableData": {
                            "id": 0
                        }
                    },
                    {
                        "type": "Member & Family",
                        "premium_amount": 11600,
                        "uuid": "e7e921cb-6010-48eb-a618-11553b247834",
                        "tableData": {
                            "id": 1
                        }
                    }
                ],
                "benefits_nuclear": [
                    {
                        "name": "Funeral",
                        "benefit_amount": 3000000,
                        "uuid": "eeb5144b-5864-4031-8165-366e06caa60f",
                        "tableData": {
                            "id": 0
                        }
                    }
                ],
                "premium_waivers": [
                    {
                        "months": "12",
                        "allowed_relationships": [
                            "Member & Family"
                        ],
                        "premium_amount": 1150,
                        "uuid": "77fd67ca-4ccc-45d0-8eca-9346c7ba8c51",
                        "tableData": {
                            "id": 0
                        }
                    },
                    {
                        "months": "12",
                        "premium_amount": 400,
                        "allowed_relationships": [
                            "Parent_In_Law",
                            "Parent"
                        ],
                        "uuid": "9d07861b-087e-4f8d-b96b-56844e95de84",
                        "tableData": {
                            "id": 1
                        }
                    }
                ],
                "annuities": [
                    {
                        "months": "6",
                        "benefit_amount": 50000,
                        "premium_amount": 500,
                        "allowed_relationships": [
                            "Member Only"
                        ],
                        "uuid": "1818e061-1020-4e5a-b2f1-4393a977415d",
                        "tableData": {
                            "id": 0
                        }
                    }
                ]
            },
            "_id": "65e84d89cf83d515744dc604"
        },
        "premiums": [],
        "fixed_indemnities": [],
        "variable_indemnities": [],
        "cashback": []
    },
    {
        "created_at": "2024-01-31T09:26:30.416Z",
        "guid": "9d0ed6cc-ae34-4528-b648-9f2c42fe6b47",
        "name": "Plan 7",
        "code": "Plan_7",
        "type": "Paid",
        "cover_type": "Family",
        "minimum_age": 18,
        "maximum_age": 100,
        "waiting_period_days": 150,
        "lapse_period_days": 120,
        "cool_off_period_hours": 0,
        "debit_grace_days": 30,
        "partner_guid": "accessbank",
        "eligibility_threshold": 0,
        "active": true,
        "tag": "",
        "notes": "",
        "membership_configs": {
            "guid": "60074433-2de2-4b54-9964-f974e59e9735",
            "product_guid": "9d0ed6cc-ae34-4528-b648-9f2c42fe6b47",
            "created_at": "2024-01-31T09:34:06.031Z",
            "content": {
                "nuclear": [
                    {
                        "relationship": "Principal",
                        "age_range": {
                            "min": 18,
                            "max": 75
                        },
                        "max_count": 1
                    },
                    {
                        "relationship": "Spouse",
                        "age_range": {
                            "min": 18,
                            "max": 75
                        },
                        "max_count": 1
                    },
                    {
                        "relationship": "Child",
                        "age_range": {
                            "min": 0,
                            "max": 21
                        },
                        "max_count": 6
                    }
                ],
                "extended": [
                    {
                        "relationship": "Parent",
                        "age_range": {
                            "min": 18,
                            "max": 84
                        },
                        "max_count": 2,
                        "male_count": 1,
                        "female_count": 1
                    },
                    {
                        "relationship": "Parent_In_Law",
                        "age_range": {
                            "min": 18,
                            "max": 84
                        },
                        "max_count": 2,
                        "male_count": 1,
                        "female_count": 1
                    }
                ],
                "premiums": [
                    {
                        "entry_age": 18,
                        "exit_age": 84,
                        "benefit_amount": 5000000,
                        "premium_rate": 8900,
                        "tableData": {
                            "id": 0
                        }
                    }
                ],
                "members_payout_plan": [],
                "add_ons": [
                    {
                        "name": "Tombstone",
                        "benefit_amount_in_cents": 1200000,
                        "premium_amount_in_cents": 2500,
                        "allowed_relationships": [
                            "Member Only"
                        ],
                        "uuid": "6953e390-4b45-49e2-9b86-bb5329909d80",
                        "tableData": {
                            "id": 0
                        }
                    },
                    {
                        "name": "Tombstone",
                        "benefit_amount_in_cents": 1200000,
                        "premium_amount_in_cents": 5400,
                        "allowed_relationships": [
                            "Member & Family"
                        ],
                        "uuid": "7db5c64d-6b0f-4c7f-b0d0-f7f940aa21c0",
                        "tableData": {
                            "id": 1
                        }
                    },
                    {
                        "name": "Tombstone",
                        "benefit_amount_in_cents": 1200000,
                        "premium_amount_in_cents": 3300,
                        "allowed_relationships": [
                            "Parent",
                            "Parent_In_Law"
                        ],
                        "uuid": "334b7762-0648-4ab5-9aac-c3d3954fc8d1"
                    }
                ],
                "premium_nuclear": [
                    {
                        "type": "Member Only",
                        "premium_amount": 9100,
                        "uuid": "1e36c5ab-d4e9-4611-9b87-5d5c67bfc52c",
                        "tableData": {
                            "id": 0
                        }
                    },
                    {
                        "type": "Member & Family",
                        "premium_amount": 16200,
                        "uuid": "2879c763-405f-4f76-9b93-7ef6d2a7f48c",
                        "tableData": {
                            "id": 1
                        }
                    }
                ],
                "benefits_nuclear": [
                    {
                        "name": "Funeral",
                        "benefit_amount": 5000000,
                        "uuid": "cdea0075-4856-47de-9704-5f5ab5124e6b",
                        "tableData": {
                            "id": 0
                        }
                    }
                ],
                "premium_waivers": [
                    {
                        "months": "12",
                        "allowed_relationships": [
                            "Member & Family"
                        ],
                        "premium_amount": 1350,
                        "uuid": "8b8e5a12-1d47-46dd-95de-7a6a58c0bbd5",
                        "tableData": {
                            "id": 0
                        }
                    },
                    {
                        "months": "12",
                        "allowed_relationships": [
                            "Parent",
                            "Parent_In_Law"
                        ],
                        "premium_amount": 550,
                        "uuid": "b858fffd-b49c-45f2-8b12-12ac2f87c9e3",
                        "tableData": {
                            "id": 1
                        }
                    }
                ],
                "annuities": [
                    {
                        "months": "6",
                        "benefit_amount": 50000,
                        "premium_amount": 500,
                        "allowed_relationships": [
                            "Member Only"
                        ],
                        "uuid": "b24b694c-f7c0-471a-9f8b-cf7785e92ed7",
                        "tableData": {
                            "id": 0
                        }
                    }
                ]
            },
            "_id": "65ba140ef9ef7df443dde7f7"
        },
        "premiums": [],
        "fixed_indemnities": [],
        "variable_indemnities": [],
        "cashback": []
    }
]




export const familyClanCoverPremiumRates = [
  {
    cover_amount: 7500,
    option: '7,500',
    premiums: [
      {
        "min_total_members": 0,
        "max_total_members": 10,
        "premium_amount": 95.67
      },
      {
        "min_total_members": 11,
        "max_total_members": 15,
        "premium_amount": 139.4
      },
      {
        "min_total_members": 16,
        "max_total_members": 20,
        "premium_amount": 183.14
      },
      {
        "min_total_members": 21,
        "max_total_members": 25,
        "premium_amount": 226.87
      },
      {
        "min_total_members": 26,
        "max_total_members": 30,
        "premium_amount": 226.87
      }
    ]
 
  },
  {
    cover_amount: 10000,
    option: '10,000',
    premiums: [
      {
        "min_total_members": 0,
        "max_total_members": 10,
        "premium_amount": 121.38
      },
      {
        "min_total_members": 11,
        "max_total_members": 15,
        "premium_amount": 178.05
      },
      {
        "min_total_members": 16,
        "max_total_members": 20,
        "premium_amount": 234.72
      },
      {
        "min_total_members": 21,
        "max_total_members": 25,
        "premium_amount": 291.39
      },
      {
        "min_total_members": 26,
        "max_total_members": 30,
        "premium_amount": 348.06
      }
    ]
 
  },
  {
    cover_amount: 15000,
    option: '15,000',
    premiums: [
      {
        "min_total_members": 0,
        "max_total_members": 10,
        "premium_amount": 172.68
      },
      {
        "min_total_members": 11,
        "max_total_members": 15,
        "premium_amount":  225.08
      },
      {
        "min_total_members": 16,
        "max_total_members": 20,
        "premium_amount": 337.49
      },
      {
        "min_total_members": 21,
        "max_total_members": 25,
        "premium_amount": 419.89
      },
      {
        "min_total_members": 26,
        "max_total_members": 30,
        "premium_amount": 502.3
      }
    ]
 
  },
  {
    cover_amount: 20000,
    option: '20,000',
    premiums: [
      {
        "min_total_members": 0,
        "max_total_members": 10,
        "premium_amount": 223.92
      },
      {
        "min_total_members": 11,
        "max_total_members": 15,
        "premium_amount":  332.06
      },
      {
        "min_total_members": 16,
        "max_total_members": 20,
        "premium_amount": 440.2
      },
      {
        "min_total_members": 21,
        "max_total_members": 25,
        "premium_amount": 548.34
      },
      {
        "min_total_members": 26,
        "max_total_members": 30,
        "premium_amount": 656.48
      }
    ]
 
  },
];

export const motsheloCoverPremiumsRates = [
  {
    cover_amount: 7500,
    option: 'Option 1',
    premiums: [
      {
        "min_total_members": 0,
        "max_total_members": 10,
        "premium_amount": 187
      },
      {
        "min_total_members": 11,
        "max_total_members": 15,
        "premium_amount": 238
      },
      {
        "min_total_members": 16,
        "max_total_members": 20,
        "premium_amount": 263
      },
      {
        "min_total_members": 21,
        "max_total_members": 25,
        "premium_amount": 314
      },
      {
        "min_total_members": 26,
        "max_total_members": 30,
        "premium_amount": 360
      }
    ]
  },
  {
    cover_amount: 10000,
    option: 'Option 2',
    premiums: [
      {
        "min_total_members": 0,
        "max_total_members": 10,
        "premium_amount": 232
      },
      {
        "min_total_members": 11,
        "max_total_members": 15,
        "premium_amount": 295
      },
      {
        "min_total_members": 16,
        "max_total_members": 20,
        "premium_amount": 327
      },
      {
        "min_total_members": 21,
        "max_total_members": 25,
        "premium_amount": 390
      },
      {
        "min_total_members": 26,
        "max_total_members": 30,
        "premium_amount": 447
      }
    ]
  },
  {
    cover_amount: 15000,
    option: 'Option 3',
    premiums: [
      {
        "min_total_members": 0,
        "max_total_members": 10,
        "premium_amount": 341
      },
      {
        "min_total_members": 11,
        "max_total_members": 15,
        "premium_amount": 436
      },
      {
        "min_total_members": 16,
        "max_total_members": 20,
        "premium_amount": 483
      },
      {
        "min_total_members": 21,
        "max_total_members": 25,
        "premium_amount": 578
      },
      {
        "min_total_members": 26,
        "max_total_members": 30,
        "premium_amount": 663
      }
    ]
  },
  {
    cover_amount: 20000,
    option: 'Option 4',
    premiums: [
      {
        "min_total_members": 0,
        "max_total_members": 10,
        "premium_amount": 452
      },
      {
        "min_total_members": 11,
        "max_total_members": 15,
        "premium_amount": 579
      },
      {
        "min_total_members": 16,
        "max_total_members": 20,
        "premium_amount": 642
      },
      {
        "min_total_members": 21,
        "max_total_members": 25,
        "premium_amount": 768
      },
      {
        "min_total_members": 26,
        "max_total_members": 30,
        "premium_amount": 882
      }
    ]
  },
  
];